import React from 'react'
import CheckboxFieldSet from '../common/CheckboxFieldSet'

export default function LgcCustomerType(props) {
  const { attributes } = props

  return (
    <div>
      <CheckboxFieldSet
        {...props}
        options={['full_benefits_build', 'network_mapping']}
        label="Large Group Custom Options"
        startCase
        disabled={!attributes.lgc_customer}
      />
    </div>
  )
}
